<template>
	<div class="mb-3">
		<hr class="mb-2 mt-0" />
		<PermissionTitle
			v-model="item.expand"
			:title="item.module"
			:check="item.active"
			@check="($event)=>checked(item, $event)"
		/>
		<b-collapse v-model="item.expand">
			<div v-if="item.permissions">
				<b-list-group
					v-for="(permission, i) of item.permissions"
					:key="i"
				>
					<b-list-group-item
						class="d-flex flex-row justify-content-between"
					>
						<span class="text-muted">{{
							permission.description
						}}</span>
						<b-form-checkbox
							:value="true"
							:disabled="unableEdit"
							:unchecked-value="false"
							:checked="permission.active"
							@change="checked(permission, $event)"
						>
						</b-form-checkbox
					></b-list-group-item>
				</b-list-group>
			</div>
			<div v-else>
				<div
					class="ml-3 mb-3"
					style="border-left: 5px solid grey;"
					v-for="(child, j) of item.children"
					:key="j"
				>
					<PermissionTitle
						v-model="child.expand"
						:title="child.module"
						:check="child.active"
						@check="($event)=>checked(child, $event)"
						class="ml-2"
					/>

					<b-collapse v-model="child.expand">
						<b-list-group
							class="ml-2"
							v-for="(permission, i) of child.permissions"
							:key="i"
						>
							<b-list-group-item
								class="d-flex flex-row justify-content-between"
							>
								<span class="text-muted">{{
									permission.description
								}}</span>
								<b-form-checkbox
									:disabled="unableEdit"
									:value="true"
									:unchecked-value="false"
									:checked="permission.active"
									@change="checked(permission, $event)"
								>
								</b-form-checkbox
							></b-list-group-item>
						</b-list-group>
					</b-collapse>
				</div>
			</div>
		</b-collapse>
	</div>
</template>

<script>
import PermissionTitle from "./PermissionTitle";
import { mapMutations } from "vuex";
export default {
	components: {
		PermissionTitle
	},
	props: {
		unableEdit: Boolean,
		item: Object
	},
	methods: {
		...mapMutations("permission", ["DELETE_PERMISSION", "SET_PERMISSION"]),
		checked(object, e) {
			const map = arr => (arr ? arr.map(fix) : null);
			const fix = item => {
				item.active = e;
				if (item.permissions) {
					return {
						...item,
						permissions: map(item.permissions)
					};
				}
				if (item.children) {
					return {
						...item,
						children: map(item.children)
					};
				}
				this.handlerState(item, e);
				return item;
			};
			if (object.permissions || object.children) {
				map(object.permissions || object.children);
			} else {
				this.handlerState(object, e);
			}
		},
		handlerState(item, e) {
			if (e) {
				this.SET_PERMISSION(item.permission);
			} else {
				this.DELETE_PERMISSION(item.permission);
			}
		}
	}
};
</script>

<style></style>
